import agb from "@/../public/locales/en/agb.json";
import common from "@/../public/locales/en/common.json";
import country from "@/../public/locales/en/country.json";
import dataerrors from "@/../public/locales/en/dataerrors.json";
import dataprotection from "@/../public/locales/en/dataprotection.json";
import email from "@/../public/locales/en/email.json";
import faq from "@/../public/locales/en/faq.json";
import imprint from "@/../public/locales/en/imprint.json";
import registerconfirmation from "@/../public/locales/en/registerconfirmation.json";
import profile from "@/../public/locales/en/profile.json";
import advertiser from "@/../public/locales/en/advertiser.json";
import subscription from "@/../public/locales/en/subscription.json";
import registerAdvertiser from "@/../public/locales/en/registerAdvertiser.json";
import registerTravelCompany from "@/../public/locales/en/registerTravelCompany.json";
import paymentCard from "@/../public/locales/en/paymentCard.json";
import registerData from "@/../public/locales/en/registerData.json";
import zodCustomErrors from "@/../public/locales/en/zodCustomErrors.json";
import createSubscription from "@/../public/locales/en/createSubscription.json";
import deleteAccountConfirmed from "@/../public/locales/en/deleteAccountConfirmed.json";
import busrequests from "@/../public/locales/en/busrequests.json";
import buspartners from "@/../public/locales/en/buspartners.json";
import imageCropTool from "@/../public/locales/en/imageCropTool.json";
import paymentMethod from "@/../public/locales/en/paymentMethod.json";
import zodBusrequestPaths from "@/../public/locales/en/zodBusrequestPaths.json";
import passiveCompanies from "@/../public/locales/en/passiveCompanies.json";
import addressForm from "@/../public/locales/en/addressForm.json";
import newsletter from "@/../public/locales/en/newsletter.json";
import busunternehmen from "@/../public/locales/en/busunternehmen.json";
import homepage_seo from "@/../public/locales/en/homepage_seo.json";
import checkout from "@/../public/locales/en/checkout.json";
import navigation from "@/../public/locales/en/navigation.json";

import zodEn from "../public/locales/en/zod.json";
import { ResourceKeyRecord } from "@/types/UtilTypes";

const resources = {
  agb,
  buspartners,
  common,
  country,
  dataerrors,
  dataprotection,
  email,
  faq,
  imprint,
  busunternehmen,
  homepage_seo,
  registerconfirmation,
  profile,
  advertiser,
  busrequests,
  subscription,
  registerAdvertiser,
  registerTravelCompany,
  paymentCard,
  registerData,
  zod: zodEn,
  zodCustomErrors,
  createSubscription,
  deleteAccountConfirmed,
  imageCropTool,
  paymentMethod,
  zodBusrequestPaths,
  passiveCompanies,
  addressForm,
  newsletter,
  checkout,
  navigation,
} as const;

export default resources;

export const zodCustomErrorsConst = {
  PasswordRep: "PasswordRep",
  Telephone: "Telephone",
  BillingDataRequired: "BillingDataRequired",
  ServerValidation: "ServerValidation",
  PaymentIntervalRequired: "PaymentIntervalRequired",
  DuplicateEmail: "DuplicateEmail",
  DuplicateUsername: "DuplicateUsername",
  PasswordDigit: "PasswordDigit",
  PasswordLowercase: "PasswordLowercase",
  PasswordUppercase: "PasswordUppercase",
  PasswordSpecial: "PasswordSpecial",
  AddressMissing: "AddressMissing",
  DataProtectionAgreement: "DataProtectionAgreement",
  DataProtectionAndAgbAgreement: "DataProtectionAndAgbAgreement",
  DesignType: "DesignType",
  LicencePlate: "LicencePlate",
  Capacity: "Capacity",
  PasswordRequired: "PasswordRequired",
  SelectedCompaniesRequired: "SelectedCompaniesRequired",
  FutureDateRequired: "FutureDateRequired",
  AddressCity: "AddressCity",
  AddressCountry: "AddressCountry",
  AddressNumber: "AddressNumber",
  AddressPostalCode: "AddressPostalCode",
  AddressStreet: "AddressStreet",
  Website: "Website",
  DateAfterDate: "DateAfterDate",
  DateBeforeDate: "DateBeforeDate",
  HTTPSUrl: "HTTPSUrl",
  URLSchema: "URLSchema",
  AttachmentMaxSizeExceeded: "AttachmentMaxSizeExceeded",
  AttachmentMaxSizeTotalExceeded: "AttachmentMaxSizeTotalExceeded",
} as const satisfies ResourceKeyRecord<(typeof resources)["zodCustomErrors"]>;

export type ZodCustomErrors = typeof zodCustomErrorsConst;
